export default [
    "24 24",
    '<path id="Vector" d="M21 14L12 20L3 14M21 10L12 16L3 10L12 4L21 10Z" fill="none"  class="stroke-over" stroke="var(--ci-primary-color, currentColor)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>']

